import { forwardRef, type Ref, type SVGProps } from "react";
const IconSearchHeartFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.41 26.59 23.77 21A12 12 0 0 0 14 2h-1A11 11 0 0 0 2 13v1a12 12 0 0 0 19 9.77l5.64 5.64a2 2 0 0 0 2.82-2.82ZM18.17 14.87l-.23.24-3.7 3.78a.35.35 0 0 1-.51 0L10 15.11l-.23-.24a2.93 2.93 0 0 1 .27-4.29C12 9 14 11.29 14 11.29s1.67-2.34 3.9-.71a2.87 2.87 0 0 1 .27 4.29"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSearchHeartFilledSVG);
ForwardRef.displayName = "IconSearchHeartFilled";
export { ForwardRef as IconSearchHeartFilled };
